module.exports = __webpack_public_path__ + "img/m4.png";